/**
 * app：app 内打开, 如果失败跳转到 and 或 ios
 * pc： pc跳转地址
 * and：安卓跳转地址
 * ios：ios跳转地址
 * @returns
 */

import qs from 'qs'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { isAndroid, isIOS, isInApp } from 'src/common/browser'
import { setNavbar } from 'src/common/jsbridge'

import * as styles from './index.module.scss'

const DELAY = 5000
const MOBILE = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/
const IOS = 'https://apps.apple.com/app/id1424956516'
const AND =
  'https://play.google.com/store/apps/details?id=com.oceanwing.battery.cam'

const isMobile =
  typeof window !== 'undefined' && MOBILE.test(navigator.userAgent)

const Redirect = () => {
  const [urlParams, setUrlParams] = useState<qs.ParsedQs>({})
  const timer = useRef<number>(null)

  const handlePcRedirect = (params: qs.ParsedQs) => {
    const pc = params.pc
    if (pc && typeof pc === 'string') {
      window.location.href = pc
    }
  }

  const handleMobileBroswerRedirect = (params: qs.ParsedQs) => {
    const and = params.and || AND
    const ios = params.ios || IOS

    if (isIOS && ios && typeof ios === 'string') {
      window.location.href = ios
    }
    if (isAndroid && and && typeof and === 'string') {
      window.location.href = and
    }
  }

  const handleMobileRedirect = useCallback(params => {
    const { app } = params
    if (app && typeof app === 'string') {
      timer.current = window.setTimeout(() => {
        clearTimeout(timer.current)
        handleMobileBroswerRedirect(params)
      }, DELAY)
      window.location.href = app
    } else {
      handleMobileBroswerRedirect(params)
    }
  }, [])

  const handleRedirect = useCallback(() => {
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    isMobile ? handleMobileRedirect(params) : handlePcRedirect(params)
  }, [handleMobileRedirect])

  useEffect(() => {
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    setUrlParams(params)
    isInApp().then(result => {
      if (result) {
        setNavbar({
          hideNavbar: false,
          backOperation: 2,
        })
      }
    })
  }, [])

  useEffect(() => {
    setTimeout(() => {
      handleRedirect()
    }, 100)
  }, [handleRedirect])

  useEffect(() => {
    window.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        timer.current && clearTimeout(timer.current)
      }
    })
  }, [])

  return (
    <div className={styles.Page}>
      <div className={styles.PageLoad}>
        <div className={styles.LoadIcon}>
          <div className={styles.LoadRotating}></div>
        </div>
      </div>
    </div>
  )
}

export default Redirect
